import { render, staticRenderFns } from "./restaurant.vue?vue&type=template&id=1e7d5d77"
import script from "./restaurant.vue?vue&type=script&lang=js"
export * from "./restaurant.vue?vue&type=script&lang=js"
import style0 from "./restaurant.vue?vue&type=style&index=0&id=1e7d5d77&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports